"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NaiveCSVBook = void 0;
const NaiveSheet_1 = require("./NaiveSheet");
// TODO: Streaming Read should be supported
//       Currently it reads the whole file at once
class NaiveCSVBook {
    constructor(rows) {
        this.sheets = [new NaiveSheet_1.NaiveSheet("Default", rows)];
    }
}
exports.NaiveCSVBook = NaiveCSVBook;
